module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "loading-container"
    }
  }, [_c('div', {
    staticClass: "loading",
    class: {
      'nodisplay': true
    }
  }, [_c('i', {
    staticClass: "fas fa-circle-notch fa-spin fa-5x"
  })]), _vm._v(" "), _c('pageheader'), _vm._v(" "), _c('b-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('div', {
    staticClass: "body-width"
  }, [_c('b-row', [_c('b-col', [_c('summarygraph')], 1)], 1), _vm._v(" "), _c('b-row', [_c('b-col', [_c('summarylist')], 1)], 1)], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4caf5360","transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/aftersale/dashboard/summary.vue
// module id = 667
// module chunks = 0